import _objectSpread from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _createClass from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _inherits from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
// Generated by genversion.
var version = '4.2.2';
var SESSION_PREFIX = 'pkce-code-verifier';
var flagDataTypeMap;
(function (flagDataTypeMap) {
  flagDataTypeMap["s"] = "string";
  flagDataTypeMap["i"] = "integer";
  flagDataTypeMap["b"] = "boolean";
})(flagDataTypeMap || (flagDataTypeMap = {}));
var storageMap;
(function (storageMap) {
  storageMap["token_bundle"] = "kinde_token";
  storageMap["access_token"] = "kinde_access_token";
  storageMap["id_token"] = "kinde_id_token";
  storageMap["user"] = "user";
  storageMap["refresh_token"] = "kinde_refresh_token";
})(storageMap || (storageMap = {}));
var InvalidTokenError = /*#__PURE__*/function (_Error) {
  _inherits(InvalidTokenError, _Error);
  var _super = _createSuper(InvalidTokenError);
  function InvalidTokenError() {
    _classCallCheck(this, InvalidTokenError);
    return _super.apply(this, arguments);
  }
  return _createClass(InvalidTokenError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
InvalidTokenError.prototype.name = "InvalidTokenError";
function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = "0" + code;
    }
    return "%" + code;
  }));
}
function base64UrlDecode(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
}
function jwtDecode(token, options) {
  if (typeof token !== "string") {
    throw new InvalidTokenError("Invalid token specified: must be a string");
  }
  options || (options = {});
  var pos = options.header === true ? 0 : 1;
  var part = token.split(".")[pos];
  if (typeof part !== "string") {
    throw new InvalidTokenError("Invalid token specified: missing part #".concat(pos + 1));
  }
  var decoded;
  try {
    decoded = base64UrlDecode(part);
  } catch (e) {
    throw new InvalidTokenError("Invalid token specified: invalid base64 for part #".concat(pos + 1, " (").concat(e.message, ")"));
  }
  try {
    return JSON.parse(decoded);
  } catch (e) {
    throw new InvalidTokenError("Invalid token specified: invalid json for part #".concat(pos + 1, " (").concat(e.message, ")"));
  }
}
var hasCookie = function hasCookie(name) {
  var _document$cookie$spli;
  return (_document$cookie$spli = document.cookie.split('; ').find(function (row) {
    return row.split('=')[0] === name;
  })) === null || _document$cookie$spli === void 0 ? void 0 : _document$cookie$spli.split('=')[1];
};

// Base64-urlencodes the input string
function base64UrlEncode(str) {
  // Convert the ArrayBuffer to string using Uint8 array to conver to what btoa accepts.
  // btoa accepts chars only within ascii 0-255 and base64 encodes them.
  // Then convert the base64 encoded to base64url encoded
  //   (replace + with -, replace / with _, trim trailing =)
  var numberArray = Array.from(new Uint8Array(str));
  return btoa(String.fromCharCode.apply(null, numberArray)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

// Calculate the SHA256 hash of the input text.
// Returns a promise that resolves to an ArrayBuffer
function sha256(plain) {
  var encoder = new TextEncoder();
  var data = encoder.encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
}

// Return the base64-urlencoded sha256 hash for the PKCE challenge
function pkceChallengeFromVerifier(_x) {
  return _pkceChallengeFromVerifier.apply(this, arguments);
}
function _pkceChallengeFromVerifier() {
  _pkceChallengeFromVerifier = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(v) {
    var hashed;
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return sha256(v);
          case 2:
            hashed = _context16.sent;
            return _context16.abrupt("return", base64UrlEncode(hashed));
          case 4:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _pkceChallengeFromVerifier.apply(this, arguments);
}
function randomString() {
  var array = new Uint32Array(28);
  window.crypto.getRandomValues(array);
  return Array.from(array, function (dec) {
    return ('0' + dec.toString(16)).substr(-2);
  }).join('');
}
var LEEWAY = 60;
var isJWTActive = function isJWTActive(jwtToken) {
  var unixTime = Math.floor(Date.now() / 1000);
  return jwtToken.exp + LEEWAY > unixTime;
};
var setupChallenge = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(authorizationEndpoint, appState) {
    var state, code_verifier, code_challenge, url;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = randomString();
            code_verifier = randomString(); // the secret
            // Hash and base64-urlencode the secret to use as the challenge
            _context.next = 4;
            return pkceChallengeFromVerifier(code_verifier);
          case 4:
            code_challenge = _context.sent;
            sessionStorage.setItem("".concat(SESSION_PREFIX, "-").concat(state), JSON.stringify({
              codeVerifier: code_verifier,
              appState: appState
            }));
            // Build and encode the authorisation request url
            url = new URL(authorizationEndpoint);
            return _context.abrupt("return", {
              state: state,
              code_challenge: code_challenge,
              url: url
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function setupChallenge(_x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var createStore = function createStore() {
  var items = {};
  var getItem = function getItem(key) {
    return items[key];
  };
  var setItem = function setItem(key, value) {
    items[key] = value;
  };
  var removeItem = function removeItem(key) {
    delete items[key];
  };
  var reset = function reset() {
    items = {};
  };
  return {
    reset: reset,
    getItem: getItem,
    removeItem: removeItem,
    setItem: setItem
  };
};
var store = createStore();
var getClaim = function getClaim(claim) {
  var tokenKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'access_token';
  var token = store.getItem("kinde_".concat(tokenKey));
  return token ? {
    name: claim,
    value: token[claim]
  } : null;
};
var getClaimValue = function getClaimValue(claim) {
  var tokenKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'access_token';
  var obj = getClaim(claim, tokenKey);
  return obj && obj.value;
};
var getFlag = function getFlag(code, defaultValue, flagType) {
  var flags = getClaimValue('feature_flags');
  var flag = flags && flags[code] ? flags[code] : {};
  if (flag.v == null && defaultValue == null) {
    throw Error("Flag ".concat(code, " was not found, and no default value has been provided"));
  }
  if (flagType && flag.t && flagType !== flag.t) {
    throw Error("Flag ".concat(code, " is of type ").concat(flagDataTypeMap[flag.t], " - requested type ").concat(flagDataTypeMap[flagType]));
  }
  return {
    code: code,
    type: flagDataTypeMap[flag.t || flagType],
    value: flag.v == null ? defaultValue : flag.v,
    is_default: flag.v == null
  };
};
var getBooleanFlag = function getBooleanFlag(code, defaultValue) {
  try {
    var flag = getFlag(code, defaultValue, 'b');
    return flag.value;
  } catch (err) {
    console.error(err);
    return err;
  }
};
var getIntegerFlag = function getIntegerFlag(code, defaultValue) {
  try {
    var flag = getFlag(code, defaultValue, 'i');
    return flag.value;
  } catch (err) {
    console.error(err);
    return err;
  }
};
var getStringFlag = function getStringFlag(code, defaultValue) {
  try {
    var flag = getFlag(code, defaultValue, 's');
    return flag.value;
  } catch (err) {
    console.error(err);
    return err;
  }
};
var getUserOrganizations = function getUserOrganizations() {
  var _getClaimValue;
  var orgCodes = (_getClaimValue = getClaimValue('org_codes', 'id_token')) !== null && _getClaimValue !== void 0 ? _getClaimValue : [];
  return {
    orgCodes: orgCodes
  };
};
var PAYLOAD_CLAIMS = ['iss', 'azp'];
var isTokenValid = function isTokenValid(token, config) {
  if (!token) {
    throw new Error('ID token is required');
  }
  PAYLOAD_CLAIMS.forEach(function (claim) {
    if (!token.payload[claim]) {
      throw new Error("(".concat(claim, ") claim is required."));
    }
    if (token.payload[claim] !== config[claim]) {
      throw new Error("".concat(claim, " claim mismatch. Expected: \"").concat(config[claim], "\", Received: \"").concat(token.payload[claim], "\""));
    }
  });
  if (token.header.alg !== 'RS256') {
    throw new Error("Unsupported signature alg. Expected: \"RS256\", Received: \"".concat(token.header.alg, "\""));
  }
  if (config.aud) {
    if (!Array.isArray(token.payload.aud)) {
      throw new Error('(aud) claim must be an array');
    }
    var configAud = config.aud.split(' ');
    var allConfigAudExistInPayload = configAud.every(function (element) {
      return token.payload.aud.includes(element);
    });
    if (!allConfigAudExistInPayload) {
      throw new Error("(aud) claim mismatch. Expected: \"".concat(config.aud, "\", Received: \"").concat(token.payload.aud.join(', '), "\""));
    }
  }
  var isJWTExpired = !isJWTActive(token.payload);
  if (isJWTExpired) {
    throw new Error("Token expired");
  }
  return true;
};
var isCustomDomain = function isCustomDomain(url) {
  var domain = new URL(url);
  var bareDomain = domain.hostname.split('.').slice(-2).join('.');
  return bareDomain !== 'kinde.com';
};
var createKindeClient = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(options) {
    var audience, clientId, domain, _options$is_dangerous, is_dangerously_use_local_storage, redirect_uri, _options$logout_uri, logout_uri, on_redirect_callback, on_error_callback, _options$scope, scope, proxy_redirect_uri, _framework, _frameworkVersion, client_id, isDevelopment, isUseCookie, isUseLocalStorage, config, setStore, useRefreshToken, getTokenType, getToken, getIdToken, isAuthenticated, getPermissions, getPermission, getOrganization, clearUrlParams, handleRedirectToApp, redirectToKinde, register, login, createOrg, getUser, getUserProfile, logout, init, isKindeRedirect;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            if (options) {
              _context15.next = 2;
              break;
            }
            throw Error('Please provide your Kinde credentials');
          case 2:
            if (!(options !== Object(options))) {
              _context15.next = 4;
              break;
            }
            throw Error('The Kinde SDK must be initiated with an object');
          case 4:
            audience = options.audience, clientId = options.client_id, domain = options.domain, _options$is_dangerous = options.is_dangerously_use_local_storage, is_dangerously_use_local_storage = _options$is_dangerous === void 0 ? false : _options$is_dangerous, redirect_uri = options.redirect_uri, _options$logout_uri = options.logout_uri, logout_uri = _options$logout_uri === void 0 ? redirect_uri : _options$logout_uri, on_redirect_callback = options.on_redirect_callback, on_error_callback = options.on_error_callback, _options$scope = options.scope, scope = _options$scope === void 0 ? 'openid profile email offline' : _options$scope, proxy_redirect_uri = options.proxy_redirect_uri, _framework = options._framework, _frameworkVersion = options._frameworkVersion;
            if (!(audience && typeof audience !== 'string')) {
              _context15.next = 7;
              break;
            }
            throw Error('Please supply a valid audience for your api');
          case 7:
            if (!(scope && typeof scope !== 'string')) {
              _context15.next = 9;
              break;
            }
            throw Error('Please supply a valid scope');
          case 9:
            if (!(!redirect_uri || typeof options.redirect_uri !== 'string')) {
              _context15.next = 11;
              break;
            }
            throw Error('Please supply a valid redirect_uri for your users to be redirected after successful authentication');
          case 11:
            if (!(!domain || typeof domain !== 'string')) {
              _context15.next = 13;
              break;
            }
            throw Error('Please supply a valid Kinde domain so we can connect to your account');
          case 13:
            if (!(typeof is_dangerously_use_local_storage !== 'boolean')) {
              _context15.next = 15;
              break;
            }
            throw TypeError('Please supply a boolean value for is_dangerously_use_local_storage');
          case 15:
            client_id = clientId || 'spa@live'; // If code is running on localhost, it's a development environment
            isDevelopment = location.hostname === 'localhost' || location.hostname === '127.0.0.1'; // Indicates using a custom domain on a production environment
            isUseCookie = !isDevelopment && !is_dangerously_use_local_storage && isCustomDomain(domain);
            isUseLocalStorage = isDevelopment || is_dangerously_use_local_storage;
            config = {
              audience: audience,
              client_id: client_id,
              redirect_uri: redirect_uri,
              authorization_endpoint: "".concat(domain, "/oauth2/auth"),
              token_endpoint: "".concat(domain, "/oauth2/token"),
              requested_scopes: scope,
              domain: domain,
              _framework: _framework,
              _frameworkVersion: _frameworkVersion
            };
            setStore = function setStore(data) {
              if (!data || data.error) return;
              var idToken = jwtDecode(data.id_token);
              var idTokenHeader = jwtDecode(data.id_token, {
                header: true
              });
              var accessToken = jwtDecode(data.access_token);
              var accessTokenHeader = jwtDecode(data.access_token, {
                header: true
              });
              var validatorOptions = {
                iss: domain,
                azp: clientId,
                aud: audience
              };
              isTokenValid({
                payload: idToken,
                header: idTokenHeader
              }, _objectSpread(_objectSpread({}, validatorOptions), {}, {
                aud: clientId
              }));
              isTokenValid({
                payload: accessToken,
                header: accessTokenHeader
              }, validatorOptions);
              {
                store.setItem(storageMap.token_bundle, data);
                store.setItem(storageMap.access_token, accessToken);
                store.setItem(storageMap.id_token, idToken);
                if (idToken.sub) {
                  store.setItem(storageMap.user, {
                    id: idToken.sub,
                    given_name: idToken.given_name,
                    family_name: idToken.family_name,
                    email: idToken.email,
                    picture: idToken.picture
                  });
                }
                if (isUseLocalStorage) {
                  localStorage.setItem(storageMap.refresh_token, data.refresh_token);
                } else {
                  store.setItem(storageMap.refresh_token, data.refresh_token);
                }
              }
            };
            useRefreshToken = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                var _ref4,
                  tokenType,
                  localStorageRefreshToken,
                  isCallTokenEndpoint,
                  response,
                  data,
                  _args2 = arguments;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _ref4 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {
                          tokenType: storageMap.access_token
                        }, tokenType = _ref4.tokenType;
                        localStorageRefreshToken = isUseLocalStorage ? localStorage.getItem(storageMap.refresh_token) : store.getItem(storageMap.refresh_token);
                        isCallTokenEndpoint = localStorageRefreshToken || isUseCookie && hasCookie('_kbrte');
                        if (!isCallTokenEndpoint) {
                          _context2.next = 20;
                          break;
                        }
                        _context2.prev = 4;
                        _context2.next = 7;
                        return fetch(config.token_endpoint, _objectSpread(_objectSpread({
                          method: 'POST'
                        }, isUseCookie && {
                          credentials: 'include'
                        }), {}, {
                          headers: new Headers({
                            'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                            'Kinde-SDK': "\n            ".concat(config._framework || 'JavaScript', "/").concat(config._frameworkVersion || version)
                          }),
                          body: new URLSearchParams(_objectSpread({
                            client_id: config.client_id,
                            grant_type: 'refresh_token'
                          }, !isUseCookie && localStorageRefreshToken && {
                            refresh_token: localStorageRefreshToken
                          }))
                        }));
                      case 7:
                        response = _context2.sent;
                        _context2.next = 10;
                        return response.json();
                      case 10:
                        data = _context2.sent;
                        setStore(data);
                        if (!(tokenType === storageMap.id_token)) {
                          _context2.next = 14;
                          break;
                        }
                        return _context2.abrupt("return", data.id_token);
                      case 14:
                        return _context2.abrupt("return", data.access_token);
                      case 17:
                        _context2.prev = 17;
                        _context2.t0 = _context2["catch"](4);
                        console.error(_context2.t0);
                      case 20:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[4, 17]]);
              }));
              return function useRefreshToken() {
                return _ref3.apply(this, arguments);
              };
            }();
            getTokenType = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(tokenType, options) {
                var token, tokenToReturn, isTokenActive;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        token = store.getItem(storageMap.token_bundle);
                        if (!(!token || options.isForceRefresh)) {
                          _context3.next = 5;
                          break;
                        }
                        _context3.next = 4;
                        return useRefreshToken({
                          tokenType: tokenType
                        });
                      case 4:
                        return _context3.abrupt("return", _context3.sent);
                      case 5:
                        tokenToReturn = store.getItem(tokenType);
                        isTokenActive = isJWTActive(tokenToReturn);
                        if (!isTokenActive) {
                          _context3.next = 11;
                          break;
                        }
                        return _context3.abrupt("return", tokenType === storageMap.access_token ? token.access_token : token.id_token);
                      case 11:
                        _context3.next = 13;
                        return useRefreshToken({
                          tokenType: tokenType
                        });
                      case 13:
                        return _context3.abrupt("return", _context3.sent);
                      case 14:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));
              return function getTokenType(_x5, _x6) {
                return _ref5.apply(this, arguments);
              };
            }();
            getToken = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                var options,
                  _args4 = arguments;
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        options = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
                        _context4.next = 3;
                        return getTokenType(storageMap.access_token, options);
                      case 3:
                        return _context4.abrupt("return", _context4.sent);
                      case 4:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));
              return function getToken() {
                return _ref6.apply(this, arguments);
              };
            }();
            getIdToken = /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                var options,
                  _args5 = arguments;
                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        options = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                        _context5.next = 3;
                        return getTokenType(storageMap.id_token, options);
                      case 3:
                        return _context5.abrupt("return", _context5.sent);
                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));
              return function getIdToken() {
                return _ref7.apply(this, arguments);
              };
            }();
            isAuthenticated = /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                var accessToken, isTokenActive;
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        accessToken = store.getItem(storageMap.access_token);
                        if (accessToken) {
                          _context6.next = 3;
                          break;
                        }
                        return _context6.abrupt("return", false);
                      case 3:
                        isTokenActive = isJWTActive(accessToken);
                        if (!isTokenActive) {
                          _context6.next = 6;
                          break;
                        }
                        return _context6.abrupt("return", true);
                      case 6:
                        _context6.next = 8;
                        return useRefreshToken();
                      case 8:
                        return _context6.abrupt("return", true);
                      case 9:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }));
              return function isAuthenticated() {
                return _ref8.apply(this, arguments);
              };
            }();
            getPermissions = function getPermissions() {
              var _getClaimValue2;
              var orgCode = getClaimValue('org_code');
              var permissions = (_getClaimValue2 = getClaimValue('permissions')) !== null && _getClaimValue2 !== void 0 ? _getClaimValue2 : [];
              return {
                permissions: permissions,
                orgCode: orgCode
              };
            };
            getPermission = function getPermission(key) {
              var _getClaimValue3;
              var orgCode = getClaimValue('org_code');
              var permissions = (_getClaimValue3 = getClaimValue('permissions')) !== null && _getClaimValue3 !== void 0 ? _getClaimValue3 : [];
              return {
                isGranted: permissions.some(function (p) {
                  return p === key;
                }),
                orgCode: orgCode
              };
            };
            getOrganization = function getOrganization() {
              var orgCode = getClaimValue('org_code');
              return {
                orgCode: orgCode
              };
            };
            clearUrlParams = function clearUrlParams() {
              var url = new URL(window.location.toString());
              url.search = '';
              window.history.pushState({}, '', url);
            };
            handleRedirectToApp = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(q) {
                var code, state, error, stringState, _error, errorDescription, _JSON$parse, _appState, _JSON$parse2, appState, codeVerifier, response, data, user;
                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        code = q.get('code');
                        state = q.get('state');
                        error = q.get('error');
                        stringState = sessionStorage.getItem("".concat(SESSION_PREFIX, "-").concat(state)); // Verify state
                        if (stringState) {
                          _context7.next = 8;
                          break;
                        }
                        console.error('Invalid state');
                        _context7.next = 35;
                        break;
                      case 8:
                        if (!error) {
                          _context7.next = 16;
                          break;
                        }
                        _error = q.get('error');
                        errorDescription = q.get('error_description');
                        clearUrlParams();
                        sessionStorage.removeItem("".concat(SESSION_PREFIX, "-").concat(state));
                        _JSON$parse = JSON.parse(stringState), _appState = _JSON$parse.appState;
                        if (on_error_callback) {
                          on_error_callback({
                            error: _error,
                            errorDescription: errorDescription,
                            state: state,
                            appState: _appState
                          });
                        } else {
                          window.location.href = _appState.kindeOriginUrl;
                        }
                        return _context7.abrupt("return", false);
                      case 16:
                        _JSON$parse2 = JSON.parse(stringState), appState = _JSON$parse2.appState, codeVerifier = _JSON$parse2.codeVerifier; // Exchange authorisation code for an access token
                        _context7.prev = 17;
                        _context7.next = 20;
                        return fetch(config.token_endpoint, _objectSpread(_objectSpread({
                          method: 'POST'
                        }, isUseCookie && {
                          credentials: 'include'
                        }), {}, {
                          headers: new Headers({
                            'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                            'Kinde-SDK': "".concat(config._framework || 'JavaScript', "/").concat(config._frameworkVersion || version)
                          }),
                          body: new URLSearchParams({
                            client_id: config.client_id,
                            code: code,
                            code_verifier: codeVerifier,
                            grant_type: 'authorization_code',
                            redirect_uri: config.redirect_uri
                          })
                        }));
                      case 20:
                        response = _context7.sent;
                        _context7.next = 23;
                        return response.json();
                      case 23:
                        data = _context7.sent;
                        setStore(data);
                        // Remove auth code from address bar
                        clearUrlParams();
                        sessionStorage.removeItem("".concat(SESSION_PREFIX, "-").concat(state));
                        user = getUser();
                        if (on_redirect_callback) {
                          on_redirect_callback(user, appState);
                        }
                        _context7.next = 35;
                        break;
                      case 31:
                        _context7.prev = 31;
                        _context7.t0 = _context7["catch"](17);
                        console.error(_context7.t0);
                        sessionStorage.removeItem("".concat(SESSION_PREFIX, "-").concat(state));
                      case 35:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, null, [[17, 31]]);
              }));
              return function handleRedirectToApp(_x7) {
                return _ref9.apply(this, arguments);
              };
            }();
            redirectToKinde = /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(options) {
                var _options$app_state, app_state, prompt, is_create_org, _options$org_name, org_name, org_code, _options$authUrlParam, authUrlParams, _yield$setupChallenge, state, code_challenge, url, searchParams, urlSearchParams;
                return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        _options$app_state = options.app_state, app_state = _options$app_state === void 0 ? {} : _options$app_state, prompt = options.prompt, is_create_org = options.is_create_org, _options$org_name = options.org_name, org_name = _options$org_name === void 0 ? '' : _options$org_name, org_code = options.org_code, _options$authUrlParam = options.authUrlParams, authUrlParams = _options$authUrlParam === void 0 ? {} : _options$authUrlParam;
                        if (!app_state.kindeOriginUrl) {
                          app_state.kindeOriginUrl = window.location.href;
                        }
                        _context8.next = 4;
                        return setupChallenge(config.authorization_endpoint, app_state);
                      case 4:
                        _yield$setupChallenge = _context8.sent;
                        state = _yield$setupChallenge.state;
                        code_challenge = _yield$setupChallenge.code_challenge;
                        url = _yield$setupChallenge.url;
                        searchParams = {
                          redirect_uri: redirect_uri,
                          client_id: client_id,
                          response_type: 'code',
                          scope: config.requested_scopes,
                          code_challenge: code_challenge,
                          code_challenge_method: 'S256',
                          state: state
                        };
                        if (prompt) {
                          searchParams.prompt = prompt;
                        }
                        if (org_code) {
                          searchParams.org_code = org_code;
                        }
                        if (is_create_org) {
                          searchParams.is_create_org = String(is_create_org);
                          searchParams.org_name = org_name;
                        }
                        urlSearchParams = new URLSearchParams(Object.assign(authUrlParams, searchParams));
                        if (audience) {
                          /* if multiple audiences requested it should appear multiple times in the query string */
                          audience.trim().split(/\s+/).forEach(function (aud) {
                            urlSearchParams.append('audience', aud);
                          });
                        }
                        url.search = String(urlSearchParams);
                        window.location.href = url.toString();
                      case 16:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));
              return function redirectToKinde(_x8) {
                return _ref10.apply(this, arguments);
              };
            }();
            register = /*#__PURE__*/function () {
              var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(options) {
                return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return redirectToKinde(_objectSpread(_objectSpread({}, options), {}, {
                          prompt: 'create'
                        }));
                      case 2:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));
              return function register(_x9) {
                return _ref11.apply(this, arguments);
              };
            }();
            login = /*#__PURE__*/function () {
              var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(options) {
                return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        _context10.next = 2;
                        return redirectToKinde(_objectSpread({}, options));
                      case 2:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10);
              }));
              return function login(_x10) {
                return _ref12.apply(this, arguments);
              };
            }();
            createOrg = /*#__PURE__*/function () {
              var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(options) {
                return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return redirectToKinde(_objectSpread(_objectSpread({}, options), {}, {
                          prompt: 'create',
                          is_create_org: true
                        }));
                      case 2:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee11);
              }));
              return function createOrg(_x11) {
                return _ref13.apply(this, arguments);
              };
            }();
            getUser = function getUser() {
              return store.getItem(storageMap.user);
            };
            getUserProfile = /*#__PURE__*/function () {
              var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
                var token, headers, res, json;
                return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.next = 2;
                        return getToken();
                      case 2:
                        token = _context12.sent;
                        headers = {
                          Accept: 'application/json',
                          Authorization: "Bearer ".concat(token)
                        };
                        _context12.prev = 4;
                        _context12.next = 7;
                        return fetch("".concat(config.domain, "/oauth2/v2/user_profile"), {
                          method: 'GET',
                          headers: headers
                        });
                      case 7:
                        res = _context12.sent;
                        _context12.next = 10;
                        return res.json();
                      case 10:
                        json = _context12.sent;
                        store.setItem(storageMap.user, {
                          id: json.sub,
                          given_name: json.given_name,
                          family_name: json.family_name,
                          email: json.email,
                          picture: json.picture
                        });
                        return _context12.abrupt("return", store.getItem(storageMap.user));
                      case 15:
                        _context12.prev = 15;
                        _context12.t0 = _context12["catch"](4);
                        console.error(_context12.t0);
                      case 18:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee12, null, [[4, 15]]);
              }));
              return function getUserProfile() {
                return _ref14.apply(this, arguments);
              };
            }();
            logout = /*#__PURE__*/function () {
              var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
                var url, searchParams;
                return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        url = new URL("".concat(config.domain, "/logout"));
                        try {
                          store.reset();
                          if (isUseLocalStorage) {
                            localStorage.removeItem(storageMap.refresh_token);
                          }
                          searchParams = new URLSearchParams({
                            redirect: logout_uri
                          });
                          url.search = String(searchParams);
                          window.location.href = url.toString();
                        } catch (err) {
                          console.error(err);
                        }
                      case 2:
                      case "end":
                        return _context13.stop();
                    }
                  }
                }, _callee13);
              }));
              return function logout() {
                return _ref15.apply(this, arguments);
              };
            }();
            init = /*#__PURE__*/function () {
              var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
                var q;
                return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        q = new URLSearchParams(window.location.search); // Is a redirect from Kinde Auth server
                        if (!isKindeRedirect(q)) {
                          _context14.next = 6;
                          break;
                        }
                        _context14.next = 4;
                        return handleRedirectToApp(q);
                      case 4:
                        _context14.next = 9;
                        break;
                      case 6:
                        if (!(isUseCookie || isUseLocalStorage)) {
                          _context14.next = 9;
                          break;
                        }
                        _context14.next = 9;
                        return useRefreshToken();
                      case 9:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee14);
              }));
              return function init() {
                return _ref16.apply(this, arguments);
              };
            }();
            isKindeRedirect = function isKindeRedirect(searchParams) {
              // Check if the search params hve the code parameter
              var hasOauthCode = searchParams.has('code');
              var hasError = searchParams.has('error');
              if (!hasOauthCode && !hasError) return false;
              // Also check if redirect_uri matches current url
              var _window$location = window.location,
                protocol = _window$location.protocol,
                host = _window$location.host,
                pathname = _window$location.pathname;
              var currentRedirectUri = proxy_redirect_uri || "".concat(protocol, "//").concat(host).concat(pathname);
              return currentRedirectUri === redirect_uri || currentRedirectUri === "".concat(redirect_uri, "/");
            };
            _context15.next = 42;
            return init();
          case 42:
            return _context15.abrupt("return", {
              getToken: getToken,
              getIdToken: getIdToken,
              getUser: getUser,
              getUserProfile: getUserProfile,
              login: login,
              logout: logout,
              register: register,
              isAuthenticated: isAuthenticated,
              createOrg: createOrg,
              getClaim: getClaim,
              getFlag: getFlag,
              getBooleanFlag: getBooleanFlag,
              getStringFlag: getStringFlag,
              getIntegerFlag: getIntegerFlag,
              getPermissions: getPermissions,
              getPermission: getPermission,
              getOrganization: getOrganization,
              getUserOrganizations: getUserOrganizations
            });
          case 43:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return function createKindeClient(_x4) {
    return _ref2.apply(this, arguments);
  };
}();
export { createKindeClient as default };